const shopApplyType = {
  ALL: 'ALL',
  CITY: 'CITY',
  GROUP: 'GROUP'
};

export default shopApplyType;
